// Tiện ích cho cấu trúc bài học theo PHẦN (hoạt động sư phạm).
import type { Card, LessonDoc, LessonSection } from '../types/LessonDoc'
import { genId } from './id'

export const DEFAULT_SECTION_TITLES = ['Hoạt động mở đầu', 'Hoạt động chính', 'Hoạt động kết thúc']

export function makeSection(title: string, cards: Card[] = []): LessonSection {
  return { id: genId('sec'), title, cards }
}

export function makeDefaultSections(): LessonSection[] {
  return DEFAULT_SECTION_TITLES.map((t) => makeSection(t))
}

// Chuẩn hoá doc đọc từ backend/localStorage: đảm bảo có sections hợp lệ.
// Tương thích ngược: doc cũ dạng { cards: [...] } → gói vào 1 phần "Hoạt động chính".
export function normalizeLesson(raw: any): LessonDoc {
  const doc: LessonDoc = { ...raw }
  let sections: LessonSection[] = Array.isArray(raw?.sections) ? raw.sections : []

  if (!sections.length && Array.isArray(raw?.cards) && raw.cards.length) {
    sections = [makeSection('Hoạt động chính', raw.cards)]
  }
  if (!sections.length) {
    sections = makeDefaultSections()
  }
  // Đảm bảo mỗi section có id + mảng cards
  doc.sections = sections.map((s) => ({
    id: s.id || genId('sec'),
    title: s.title || 'Phần học',
    cards: Array.isArray(s.cards) ? s.cards : [],
  }))
  delete (doc as any).cards
  return doc
}

// Đếm tổng số thẻ trong toàn bài (dùng cho hiển thị danh sách).
export function countCards(doc: any): number {
  if (Array.isArray(doc?.sections)) {
    return doc.sections.reduce((n: number, s: any) => n + (s.cards?.length || 0), 0)
  }
  return Array.isArray(doc?.cards) ? doc.cards.length : 0
}
